import {Injectable} from '@angular/core';
import * as _Highcharts from 'highcharts';
import {Boundaries, ChartSignalEntry} from '@models/pages/user-defined-page/chart-signal-entry';
import {TranslationService} from '@services/translation/translation.service';
import {ChartGaugeType} from '@constants/pages/user-defined-page/chart-gauge-type';
import {LineChartSettingsParameters} from '@models/charts/line-chart-settings-parameters';
import {Signal} from '@models/dashboard/signal';
import {
  GaugeChartAxisSettingsGeneratorService
} from '@services/charts/gauge/axis/gauge-chart-axis-settings-generator.service';
import {
  GaugeChartSeriesSettingsGeneratorService
} from '@services/charts/gauge/series/gauge-chart-series-settings-generator.service';
import {
  GaugeChartPaneSettingsGeneratorService
} from '@services/charts/gauge/pane/gauge-chart-pane-settings-generator.service';

@Injectable({
  providedIn: 'root'
})
export class GaugeChartSettingsGeneratorService {

  constructor(private translationService: TranslationService,
              private gaugeChartAxisSettingsGeneratorService: GaugeChartAxisSettingsGeneratorService,
              private gaugeChartSeriesSettingsGeneratorService: GaugeChartSeriesSettingsGeneratorService,
              private gaugeChartPaneSettingsGeneratorService: GaugeChartPaneSettingsGeneratorService) {
  }

  public generateChartOptions(chartParameters: LineChartSettingsParameters): _Highcharts.Options {

    const firstSignal = chartParameters.chartSettings.signals[0];
    const machineSignals = chartParameters.machineSignals;
    const machineSignal = this.getMachineSignalByName(firstSignal, machineSignals);

    const boundaries: Boundaries = firstSignal.boundaries;
    const gaugeType: string = (firstSignal.gaugeType === ChartGaugeType.CLASSIC) ? 'gauge' : 'solidgauge';
    return {
      chart: {
        type: gaugeType,
        margin: firstSignal.gaugeType === ChartGaugeType.MODERN ? [0,0,0,0] : [30,0,0,0],
        events: {
          render: (event) => this.renderChart(event)
        }
      },
      pane: this.gaugeChartPaneSettingsGeneratorService.generatePane(gaugeType),
      title: {
        text: this.getChartTitle(firstSignal, machineSignal)
      },
      yAxis: this.gaugeChartAxisSettingsGeneratorService.generateYAxis(gaugeType, firstSignal, machineSignal, boundaries, firstSignal.colors),
      tooltip: {
        enabled: false
      },
      credits: {
        enabled: false,
        text: String(chartParameters.chartId) //!!!DO NOT REMOVE. needed to identify the chart by id
      },
      exporting: {
        enabled: false
      },
      plotOptions: {
        gauge: {
          wrap: false
        },
        solidgauge: {
          dataLabels: {
            padding: 0,
            y: 5,
            borderWidth: 0,
            useHTML: true
          }
        }
      },
      series: this.gaugeChartSeriesSettingsGeneratorService.generateSeries(gaugeType, firstSignal, machineSignal, chartParameters.data)
    };
  }

  private renderChart(event) {
    if (!event || !event.target) {
      return;
    }
    const chart = event.target;

    chart.width = null;
    chart.height = '100%';
    chart.chartIsReady = true;
  }


  private getMachineSignalByName(chartSignal: ChartSignalEntry, machineSignals: Signal[]): Signal {
    const signal = Object.values(machineSignals).find(function (item: Signal) {
      return item.name.toLowerCase() === chartSignal.signalName.toLowerCase();
    });
    if (!signal) {
      return new Signal('', '', '', '');
    }
    return signal;
  }

  private getChartTitle(signal: any, machineSignal: Signal): string {
    const label = machineSignal ? machineSignal.label : signal.displayedText;
    return this.translationService.translate.instant(label);
  }
}
